import React from 'react'
import { Box } from '@node-space/ui-components'

interface CardArtProps {
  isFrozen?: boolean
}

export const CardArt: React.FC<CardArtProps> = ({ isFrozen = false }) => {
  return (
    <Box className="relative">
      <img
        src={`${process.env.ASSETS_URL}/cards/card-art.svg`}
        alt="Vector"
        style={isFrozen ? { filter: 'blur(0.75px)' } : undefined}
      />
      {isFrozen && (
        <img
          className="absolute left-0 top-0 opacity-75"
          src={`${process.env.ASSETS_URL}/cards/frozen-overlay.png`}
          alt="Frozen Card"
        />
      )}
    </Box>
  )
}
